<script setup>
import { onClickOutside } from '#imports'

const props = defineProps({
  label: String,
  list: Array,
  modelValue: [String, Number],
  allText: String,
  allKey: String,
  hideSearch: Boolean,
  labelClass: String,
  wrapClass: [String, Array, Object],
})
const emit = defineEmits(['update:modelValue', 'change'])
const cur = computed(() => props.list.find(v => v.key === props.modelValue) ?? {})
const searchText = ref('')
const show = ref(false)
const listRef = ref()

function handleSelect(i) {
  emit('update:modelValue', i.key)
  emit('change', i.key, i)
  clear()
}

function clear() {
  searchText.value = ''
  setTimeout(() => {
    show.value = false
  })
}

const dd = computed(() => {
  const reg = new RegExp(searchText.value, 'gi')
  const all = props.allText ? [{ label: props.allText, key: props.allKey }] : []
  return all.concat(props.list).filter(i => reg.test(i.label))
})

onClickOutside(listRef, () => {
  clear()
})
</script>

<template>
  <div>
    <slot name="label">
      <div v-if="!!label" class="mb-2 text-xs text-textTertiary" :class="labelClass">
        {{ label }}
      </div>
    </slot>
    <div ref="listRef" class="relative flex items-center px-4 border border-transparent rounded-lg cursor-pointer h-9 bg-inputDefault" :class="[{ '!border-btnPrimary': show }, wrapClass]" @click="show = true">
      <slot name="prefix" />
      <div class="flex items-center w-full h-full">
        {{ cur.label ?? allText }}
      </div>
      <slot name="suffix" />
      <SvgoCommonSelectArrow class="w-2.5 h-2" />
      <div
        v-if="show"
        class="absolute left-0 z-10 top-[calc(100%+4px)] w-full min-w-[164px]"
      >
        <div class="py-3 border rounded-lg border-border bg-fillPagePrimary">
          <div v-if="!hideSearch" class="px-3 mb-3">
            <n-input
              v-model:value="searchText"
              :placeholder="$t('搜索')"
            >
              <template #prefix>
                <SvgoCommonIconSearch class="w-4 h-4 me-1" />
              </template>
              <template #suffix>
                <svgo-common-search-clear v-show="searchText" class="w-5 h-5 cursor-pointer" @click="searchText = ''" />
              </template>
            </n-input>
          </div>
          <n-scrollbar class="max-h-[218px] flex flex-col" style="--n-scrollbar-rail-right-vertical-right: 8px !important;">
            <CommonNoData v-if="!dd.length" class="!py-6" type="search" icon-class="!w-16 !h-16" />
            <div v-else class="flex-1 px-3">
              <div v-for="i in dd" :key="i.code" class="flex items-center h-10 px-3 text-xs rounded-lg cursor-pointer text-textSecondary hover:bg-pageTertiary" :class="{ 'bg-pageTertiary !text-textPrimary font-medium': i.key === cur.key }" @click="handleSelect(i)">
                <div class="flex items-center text-xs font-medium">
                  <slot name="item" v-bind="i">
                    <span>{{ i.label }}</span>
                  </slot>
                </div>
              </div>
            </div>
          </n-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
